export default "__VITE_ASSET__8$h5UheU__"